import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { filteredHotels } from "../../../api/website/hotel/hotelApi";
import { CiLocationOn } from "react-icons/ci";
import { GoStarFill } from "react-icons/go";
import { FcApproval } from "react-icons/fc";
import { Tooltip } from "@mui/joy";
import { FaHeart } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router";
import AddButton from "../../../components/admin/usable/AddButton";
import notAvailable from "../../../assets/icons/notAvailable.svg";
import Pagination from "@mui/material/Pagination";
import { setPage } from "../../../redux/website/search/hotelFliterSlice";
const HotelListing = () => {
  const dispatch = useDispatch();
  const {
    propertyStar,
    neighbourhood,
    hotelFacilities,
    roomFacilities,
    minPrice,
    maxPrice,
    sorting,
    page,
    limit,
  } = useSelector((state) => state.hotelFilter);
  const { searchName, hotelName } = useSelector((state) => state.search);
  const [Data, setData] = useState([]);
  const [PaginationData, setPaginationData] = useState("");
  const [isLoading, setIsloading] = useState(false);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const checkIn = params.get("checkIn");
  const checkOut = params.get("checkOut");
  const navigate = useNavigate();

  useEffect(() => {
    filteredHotels(
      searchName,
      propertyStar,
      hotelName,
      neighbourhood,
      hotelFacilities,
      roomFacilities,
      minPrice,
      maxPrice,
      sorting,
      page,
      limit,
      setIsloading,
      setData,
      setPaginationData,
    );
  }, [
    searchName,
    propertyStar,
    hotelName,
    neighbourhood,
    hotelFacilities,
    roomFacilities,
    minPrice,
    maxPrice,
    sorting,
    page,
    limit,
  ]);
  useEffect(() => {}, []);
  const nights =
    (new Date(checkOut) - new Date(checkIn)) / (1000 * 60 * 60 * 24);

  const allRooms = Data.flatMap((hotel) => hotel.rooms);

  const lowestActual = Math.min(...allRooms.map((room) => room.actualPrice));
  const highestPrice = Math.max(
    ...allRooms.map((room) => room.discountedPrice),
  );
  const maxDiscount = Math.max(...allRooms.map((room) => room.discount));
  return (
    <>
      {isLoading ? (
        <>
          <div className="space-y-5">
            {Array.from({ length: 5 }).map((__, index) => {
              return (
                <div
                  key={index}
                  className="w-full h-auto lg:h-[200px] border p-3 rounded-lg animate-pulse bg-white"
                >
                  <div className="flex-none lg:flex justify-between">
                    <div className="flex-none lg:flex gap-3">
                      {/* Image */}
                      <div className="w-full lg:w-[300px] h-[170px] bg-slate-200 rounded-md"></div>

                      {/* Main Details */}
                      <div className="space-y-3 mt-3 lg:mt-0 w-full">
                        {/* Hotel Name */}
                        <div className="h-5 w-40 bg-slate-200 rounded"></div>

                        {/* Rating + Location */}
                        <div className="flex items-center gap-x-3">
                          <div className="h-4 w-10 bg-slate-200 rounded"></div>
                          <div className="h-4 w-32 bg-slate-200 rounded"></div>
                        </div>

                        {/* Facilities */}
                        <div className="flex gap-2 flex-wrap">
                          <div className="h-4 w-16 bg-slate-200 rounded"></div>
                          <div className="h-4 w-16 bg-slate-200 rounded"></div>
                          <div className="h-4 w-16 bg-slate-200 rounded"></div>
                          <div className="h-4 w-16 bg-slate-200 rounded"></div>
                        </div>

                        {/* Couple Friendly */}
                        <div className="h-4 w-28 bg-slate-200 rounded"></div>
                      </div>
                    </div>

                    {/* Price Section */}
                    <div className="self-end space-y-3 mt-3 lg:mt-0">
                      <div className="h-5 w-20 bg-slate-200 rounded"></div>

                      <div className="h-6 w-32 bg-slate-200 rounded"></div>

                      <div className="h-4 w-24 bg-slate-200 rounded"></div>

                      <div className="h-8 w-24 bg-slate-200 rounded"></div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <>
          <div className="space-y-6 ">
            {Data.length > 0 ? (
              <div className="space-y-6 ">
                {Data.map((item, index) => {
                  const lowestPrice = item.rooms?.length
                    ? Math.min(
                        ...item.rooms.map((room) => room.discountedPrice),
                      )
                    : 0;
                  return (
                    <div
                      key={index}
                      className="w-full h-auto lg:h-[200px] border p-3 rounded-lg cursor-pointer  bg-white"
                      onClick={() =>
                        navigate(`/hotel/details/${item.id}/${item.hotelName}`)
                      }
                    >
                      <div className="flex-none lg:flex justify-between gap-3">
                        <div className="block lg:flex gap-3 min-w-0 flex-1">
                          <div className="flex-shrink-0">
                            <div className="w-full lg:w-[300px] h-[170px] overflow-hidden rounded-md border relative">
                              <img
                                className="w-full h-full object-cover"
                                src={item?.images[1]?.imageLink}
                                alt=""
                              />
                              <div className="absolute top-2 left-2 w-ful h-8 overflow-hidden rounded-sm">
                                <img
                                  className="w-full h-full object-contain"
                                  src={item.hotelLogo}
                                  alt={item.hotelName}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="min-w-0 flex-1">
                            <div className="flex justify-start items-center gap-x-1">
                              <div>
                                <p className="py-2 font-bold text-md lg:text-xl text-[#2155ad] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
                                  {item.hotelName}
                                </p>
                              </div>
                              <div className="cursor-pointer">
                                <Tooltip
                                  title="Dhoorbin Featured"
                                  placement="top"
                                  size="sm"
                                >
                                  <FcApproval />
                                </Tooltip>
                              </div>
                            </div>
                            <div className="flex justify-start items-start gap-x-3 min-w-0 w-full">
                              <div className="flex justify-start items-center gap-1 text-xs text-yellow-600 bg-yellow-200 p-1 rounded-md flex-shrink-0">
                                <div>
                                  <GoStarFill />
                                </div>
                                <div>
                                  <p>{item.propertyStar}</p>
                                </div>
                              </div>
                              <div className="flex justify-start items-start gap-1 min-w-0 flex-1">
                                <div className="flex-shrink-0 mt-0.5">
                                  <CiLocationOn />
                                </div>
                                <p className="text-xs text-black/50 break-all min-w-0">
                                  {item.area}, {item.cityName},{" "}
                                  {item.divisionName}, {item.countryName}
                                </p>
                              </div>
                            </div>
                            <div className="py-5 flex gap-2 flex-wrap justify-start items-center">
                              {item?.facilities
                                ?.slice(0, 2)
                                .map((group, groupIndex) => (
                                  <div
                                    key={groupIndex}
                                    className="flex justify-start items-center gap-2 flex-wrap"
                                  >
                                    {group.facilities
                                      .slice(0, 2)
                                      .map((f, index) => (
                                        <div
                                          key={index}
                                          className="flex flex-wrap justify-start items-center gap-1"
                                        >
                                          <div className="w-4 h-4 overflow-hidden flex justify-center items-center">
                                            <img
                                              className="w-full h-full object-cover"
                                              src={f.icon}
                                              alt={f.facilityName}
                                            />
                                          </div>
                                          <div>
                                            <p className="text-xs text-black/50">
                                              {f.facilityName}
                                            </p>
                                          </div>
                                        </div>
                                      ))}
                                  </div>
                                ))}
                            </div>
                            <div>
                              {item.isCoupleFriendly === 1 && (
                                <div className=" text-pink-500 bg-pink-200 border border-pink-500 px-2 py-0.5 rounded-sm cursor-pointer w-fit">
                                  <Tooltip
                                    title={
                                      <div className="p-2">
                                        <p className="text-[10px]">
                                          No marrige certificate required
                                        </p>
                                        <p className="text-[10px]">
                                          Safety and comfort ensured
                                        </p>
                                        <p className="text-[10px]">
                                          Friendly Environment
                                        </p>
                                      </div>
                                    }
                                    placement="right"
                                    size="sm"
                                  >
                                    <div className="flex items-center justify-start gap-x-2">
                                      <div className="text-xs">
                                        <FaHeart />
                                      </div>
                                      <p className="text-xs font-semibold">
                                        Couple Friendly
                                      </p>
                                    </div>
                                  </Tooltip>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="self-end place-items-end space-y-3 flex-shrink-0">
                          <div className="bg-blue-800 text-white w-fit p-1 text-xs lg:text-sm rounded-lg">
                            <p>{maxDiscount}% off</p>
                          </div>
                          <div>
                            <p className="font-bold text-md lg:text-xl text-[#0c1f3f] capitalize bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent">
                              {(lowestPrice * nights).toFixed(0)} BDT
                            </p>
                            <span className="text-sm lg:text-md text-red-500 line-through ">
                              {(lowestActual * nights).toFixed(0)} BDT
                            </span>
                          </div>
                          <div>
                            <p className="text-xs text-black/50">
                              {nights} nights per person
                            </p>
                          </div>
                          <div>
                            <AddButton text="View Rooms" size="sm" />
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}

                <div className="flex justify-center lg:justify-between items-center bg-white py-2 px-2 rounded-md">
                  <p className=" text-xs hidden lg:block">
                    Showing {(page - 1) * limit + 1} to{" "}
                    {(page - 1) * limit + Data.length} of {PaginationData}{" "}
                    entries
                  </p>
                  <Pagination
                    count={PaginationData || 1}
                    page={page}
                    onChange={(event, value) => dispatch(setPage(value))}
                  />
                </div>
              </div>
            ) : (
              <div className="w-full h-[200px] lg:h-[600px] flex justify-center items-center">
                <img
                  src={notAvailable}
                  className="w-full h-full object-contain"
                  alt=""
                />
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default HotelListing;
